import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LuMenu, LuX, LuArrowRight } from 'react-icons/lu';

export default function PublicLayout({ children }) {
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    if (menuOpen) document.body.style.overflow = 'hidden';
    else document.body.style.overflow = '';
    return () => { document.body.style.overflow = ''; };
  }, [menuOpen]);

  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="lp">
      <nav className="lp-nav">
        <div className="lp-nav-inner">
          <Link to="/welcome" className="lp-brand">
            <img src="/favicon/favicon-96x96.png" alt="" width={28} height={28} />
            <span>Photo Harbor</span>
          </Link>
          <div className="lp-nav-desktop">
            <Link to="/features">Features</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/guide">Guide</Link>
            <Link to="/login" className="lp-nav-signin">Sign in</Link>
            <Link to="/login?mode=signup" className="lp-nav-cta">Get started</Link>
          </div>
          <button className="lp-hamburger" onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu">
            {menuOpen ? <LuX size={22} /> : <LuMenu size={22} />}
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lp-mobile-menu">
          <Link to="/features" onClick={closeMenu}>Features</Link>
          <Link to="/privacy" onClick={closeMenu}>Privacy</Link>
          <Link to="/guide" onClick={closeMenu}>Guide</Link>
          <Link to="/login" onClick={closeMenu}>Sign in</Link>
          <Link to="/login?mode=signup" className="lp-btn-primary" onClick={closeMenu}>
            Get started <LuArrowRight size={16} />
          </Link>
        </div>
      )}

      <main className="lp-page-content">
        {children}
      </main>

      <footer className="lp-footer">
        <div className="lp-footer-inner">
          <div className="lp-footer-brand">
            <img src="/favicon/favicon-96x96.png" alt="" width={24} height={24} />
            <span>Photo Harbor</span>
          </div>
          <div className="lp-footer-links">
            <Link to="/features">Features</Link>
            <Link to="/privacy">Privacy Policy</Link>
            <Link to="/security">Security</Link>
            <Link to="/guide">Guide</Link>
          </div>
          <div className="lp-footer-copy">
            &copy; {new Date().getFullYear()} Dailey Cloud. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
}
